module.exports = __webpack_public_path__ + "img/top-left.b27bc488.jpg";